import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Toast from '../../../components/toast/Toast';
import RFIDInstance from '../../../native-interact/RFID';
import { runPromiseByQueue } from '../../../js/utils';

class BtbOff extends Component {
  componentDidMount() {
    this.offBlb();
  }

  offBlb() {
    const loading = Toast.loading('正在关闭');
    runPromiseByQueue([
      RFIDInstance.stopBluetoothBroadcast.bind(RFIDInstance),
      RFIDInstance.stopBluetoothBroadcast.bind(RFIDInstance),
      RFIDInstance.stopBluetoothBroadcast.bind(RFIDInstance),
      RFIDInstance.stopBluetoothBroadcast.bind(RFIDInstance),
    ])
      .then(() => {
        loading.destroy();
        Toast.success('关闭成功');
        this.props.closePanel();
      })
      .catch(() => {
        loading.destroy();
        Toast.fail('关闭失败');
        this.props.closePanel();
      });
  }

  render() {
    return <></>;
  }
}

export default observer(BtbOff);
